// 
// Ecommlab Mega Menu on hover
// - 
// 
window.theme = window.theme || {};

theme.CustomMegaMenu = (function() {

  function CustomMegaMenu(container) {
    this.container = container;

    if(!container){
      return;
    }


    this.sectionId = this.container.id;

    this.bindElements();
    this.bindEvents();

  }

  CustomMegaMenu.prototype = {

    parseThemeData: function(){
      const themeDataContainer = document.querySelector(`[data-section="${this.sectionId}"]`)
      if (!themeDataContainer){
        console.log('error: Unable to load settings for marquee section')
        return;
      }

      const themeData = JSON.parse(themeDataContainer.innerHTML);
      if (!themeData){
        console.log('Error: Unable to find theme data');
        return;
      }
      return themeData;
    },

    bindElements: function(){
      const self = this;

      self.megaMenuItems = document.querySelectorAll('details.site-nav__details');
      self.megaMenuDetails = document.querySelectorAll('details.site-nav__details summary');
      self.pageOverlay = document.querySelector('.page-overlay'); 
      
    },

    bindEvents: async function(){
      const self = this;
      
      self.megaMenuDetails.forEach(function(item){
        item.addEventListener('click', function(event){
          if (event.target.tagName != 'A'){
            event.preventDefault();
          }
        });
      });

      self.megaMenuItems.forEach(function(item){

        item.addEventListener('focusout', function(event){
          self.pageOverlay.classList.remove('show');
        });

        item.addEventListener('mouseenter', function(event){
          self.showMegaMenu(item);
        });

        item.addEventListener('mouseleave', function(event){
          self.hideMegaMenu(item);
        });


      });
    },

    showMegaMenu: function(item){
      const self = this;
      item.open = true;
      self.pageOverlay.classList.add('show');
    },

    hideMegaMenu: function(item){
      const self = this;
      item.open = false;
      self.pageOverlay.classList.remove('show');
    },

  }

  return CustomMegaMenu;

})();


document.addEventListener('DOMContentLoaded', function() {
  let megaMenuContainer = document.querySelector('.custom-mega-menu');
  if (megaMenuContainer){
    new theme.CustomMegaMenu(megaMenuContainer);
  }
});